import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { Content, Main } from '../../../components/Layout';
import { Row, Col, Form, Modal } from 'react-bootstrap';
import IcMenos from '../../../components/Svg/IcMenos';
import IcMais from '../../../components/Svg/IcMais';
import { useParams, useNavigate } from 'react-router-dom';
import Loading from '../../../components/Loading';
import { toast } from 'react-toastify';
import Slct from '../../../components/Slct';
import styleButton from '../../../components/Button/Button.module.css'
import CheckboxList from '../../../components/CheckboxList';
import contextArrow from '../../../assets/campus-arrow.png'
import useWrapper from '../../../hooks/useWrapper';
import Button from '../../../components/Button';
import Required from '../../../components/Required';

export default function InstitutionsEdit() {
  const { setbreadcrumb, me, config } = useWrapper();
  const permissions = JSON.parse(me.permissions);

  const navigate = useNavigate();
  
  const [loadingPage, setLoadingPage] = useState(true)

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [checked, setChecked] = useState({checkState: []});
  const [validated, setValidated] = useState(false);
  const [institution, setInstitution] = useState({
    title: '',
    description: '',
    campus_name: '',
    state_id: '',
    city_id: '',
    courses: [],
    campus: []
  });
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [courses, setCourses] = useState([]);
  const [newCourse, setNewCourse] = useState('');
  const [rows, setRows] = useState([]);
  const { institucionId } = useParams();
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    let _error = [];
    document.querySelectorAll('.input-empty').forEach(e => {
      e.classList.remove('input-empty');
    })

    if(!institution.title) {
      _error.push({el: "institution.title"});
    }
    if(!institution.campus_name) {
      _error.push({el: "institution.campus_name"});
    }
    if(!state) {
      _error.push({el: "state", parent: true});
    }
    if(!city) {
      _error.push({el: "city", parent: true});
    }
    if(secondaries.find(e => !e.title)) {
      _error.push({el: "secondaries[].title"});
    }
    if(secondaries.find(e => !e.state_id)) {
      _error.push({el: "secondaries[].state_id", parent: true});
    }
    if(secondaries.find(e => !e.city_id)) {
      _error.push({el: "secondaries[].city_id", parent: true});
    }

    if(!!_error.length) {
      toast.error("Preencha todos os dados obrigatórios!");
      setTimeout(() => {
        _error.forEach(er => {
          if(er.parent) {
            document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
              el.parentElement.classList.add('input-empty')
            });
          }
          else {
            document.querySelectorAll(`*[name="${er.el}"]`).forEach(el => {
              el.classList.add('input-empty');
            });
          }
        })
      }, 200)
    }
    else {
      const data = {
        title: institution.title,
        description: institution.description,
        campus_name: institution.campus_name,
        state_id: state,
        city_id: city,
        courses: getCheckedInputs(),
        campus: secondaries
      }
  
      if (form.checkValidity() === false) {
        event.stopPropagation();
      }
      else {
        if(institucionId) {
          editContent(institucionId, data);
        }
        else {
          saveContent(data);
        }
      }
      setValidated(true);
    }
  };

  function getCheckedInputs () {
    let arrayCouses = []
    checked.checkState.forEach((inst, index) => {
      if(inst === true) {
        arrayCouses.push(parseInt(index))
      }
    });
    return arrayCouses;
  }

  async function editContent(institucionId, data) {
    try {
      setloadingRequest(true);
      await api.put(`institutions/${institucionId}`, data, config);
      setloadingRequest(false);
      toast.success('Conteúdo salvo com sucesso!');
      navigate(`/institutions`);
    } catch (error) {
      toast.error('Falha ao salvar os dados.');
    }
  }

  async function saveContent(data) {
    try {
      setloadingRequest(true);
      await api.post('institutions', data, config);
      setloadingRequest(false);
      toast.success('Conteúdo salvo com sucesso!');
      navigate(`/institutions`);
    } catch (error) {
      toast.error('Falha ao salvar os dados.');
    }
  }

  async function deleteContent(institucionId) {
    try {
      setloadingRequest(true);
      await api.delete(`institutions/${institucionId}`, config);
      setloadingRequest(false);
      toast.success('Conteúdo deletado com sucesso!');
      navigate(`/institutions`);
    } catch (error) {
      toast.error('Falha ao deletar os dados.');
    }
  }

  async function saveCourse() {
    if (newCourse !== '') {
      try {
        await api.post('courses',{
            title: newCourse,
        }, config);
        toast.success('Curso salvo com sucesso.');
        loadCourses();
        handleClose();
        setNewCourse('');
      } catch (error) {
        toast.error('Falha ao salvar o curso.');
      }
    }
    else {
      toast.warn('Nome do curso não informado.')
    }

  }

  async function loadCourses() {
    const response = await api.get('courses?order_by=az', config);
    setCourses(response.data); 
  }


  const handleCourse = event => {
    setNewCourse(event.target.value)
  }

  const handleValueString = event => {
    setInstitution({
      ...institution, 
      [event.target.name]: event.target.value  
    });
  }

  const handleCheckboxChange = event => {
    let arrayCouses = checked.checkState;
    arrayCouses[event.target.name] = event.target.checked;
    setChecked({
      ...checked,
      checkState: arrayCouses
    })
  }

  // useEffect(() => {
  //   if(institution) {
  //     setState(institution.state_id)
  //     setCity(institution.city_id)
  //   }
  // }, [institution])

  const [state, setState] = useState()
  const [city, setCity] = useState('')

  const [secondariesLoad, setSecondariesLoad] = useState([])
  useEffect(() => {
    api.get('state')
    .then(response => {
      let statesVar = []
      response.data.forEach(e => {
        statesVar.push({value: e.id, label: e.name, name: "state_id"})
      })
      setStates(statesVar)
    })
    api.get('courses?order_by=az', config)
    .then(response => {
      setCourses(response.data);
    })
    .then(() => {
      if(institucionId){
        api.get(`institutions/${institucionId}`, config)
        .then(response => {
          setInstitution(response.data);
          setState(response.data.state_id)
          setCity(response.data.city_id)
          let arrayCouses = [];
          response.data.courses.forEach(int => {
            arrayCouses[int.id] = true;
          })
          setChecked({
            ...checked,
            checkState: arrayCouses
          })
          if(response.data.state_id) {
            api.get(`cities/${response.data.state_id}`)
            .then(response => {
              setCities([])
              response.data.forEach(e => {
                setCities(cities => [...cities, {value: e.id, label: e.name, name:"city_id"}]);
              })
            })
            .then(() => {
              setLoadingPage(false)
            })
          }
          else {
            setLoadingPage(false)
          }
      
          // Fill rows with handled informations
          setSecondariesLoad(response.data.campus)
  
          let handledArrayCampus = response.data.campus.map(campus => {
            return api.get(`cities/${campus.state_id}`)
            .then(res => {
              return {
                id: campus.id,
                title: campus.title,
                state_id: campus.state_id,
                city_id: campus.city_id,
                listCities: res.data
              }
            });
          });
      
          Promise.all(handledArrayCampus).then(res => setRows(res));
  
        })
        .catch(error => {
          error.response.status === 401 && navigate('/no-permission');
        })
      }
      else {
        setLoadingPage(false)
      }
    })
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {
    if(state) {
      api.get(`cities/${state}`)
      .then(response => {
        let citiesVar = []
        response.data.forEach(e => {
          citiesVar.push({value: e.id, label: e.name, name: "city_id"})
        })
        setCities(citiesVar);
      })
      .then(() => {
        setLoadingPage(false)
      })
    } else {
      setCities([])
    }
  }, [state])


    const [secondaries, setSecondaries] = useState([]);
    const [secondaryDOM, setSecondaryDOM] = useState([])
    
    const [cities_sec, setCities_sec] = useState([])
    const states_sec = states


    useEffect(() => {
      let update = []
      secondariesLoad.forEach((e, index) => {
        api.get(`cities/${e.state_id}`)
        .then(response => {
          let citiesVar = []
          response.data.forEach(e => {
            citiesVar.push({value: e.id, label: e.name, name: "city_id"})
          })
          let citiesUpdate = [...cities_sec]
          citiesUpdate[index] = citiesVar
          setCities_sec(citiesUpdate);
        })
        .then(
          update.push({
            title: e.title,
            city_id: e.city_id,
            state_id: e.state_id,
            id: e.id
          })
        )
      })
      setSecondaries(update)
    }, [secondariesLoad.length])

    useEffect(() => {
      let rows = []
      secondaries.forEach((el, index) => {
        rows.push(
          <Row key={`sec-${index}`} className="mt-1">
            <Col>
              <Row>
                <Col>
                  <span className='lince-input_label'>Campus Secundário <Required /></span>
                  <input 
                    disabled={!permissions.institutions.update}
                    value={secondaries[index].title}
                    onChange={e => {
                      let _secondaries = [...secondaries];
                      _secondaries[index].title = e.target.value;
                      setSecondaries(_secondaries)
                    }}
                    name="secondaries[].title"
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm={1}>
                  <img src={contextArrow} alt="" />
                </Col>
                <Col>
                  <span className='lince-input_label'>Estado <Required /></span>
                  <Slct
                    isDisabled={!permissions.institutions.update}
                    options={states_sec}
                    className="w-100"
                    value={secondaries[index].state_id}
                    onChange={e => {
                      let _secondaries = [...secondaries];
                      _secondaries[index].state_id = e.value;
                      _secondaries[index].city_id = null;
                      setSecondaries(_secondaries);

                      api.get(`cities/${e.value}`)
                      .then(response => {
                        let _cities_sec = [...cities_sec];
                        _cities_sec[index] = response.data.map(e => ({
                          value: e.id,
                          label: e.name,
                          name: "city_id"
                        }))
                        setCities_sec(_cities_sec);
                      })
                      
                    }}
                    placeholder="..."
                    name="secondaries[].state_id"
                  />
                </Col>
                <Col>
                  <span className='lince-input_label'>Cidade <Required /></span>
                  <Slct
                    isDisabled={!permissions.institutions.update}
                    options={(!!cities_sec[index]) ? cities_sec[index] : []}
                    className="w-100"
                    value={secondaries[index].city_id}
                    onChange={e => {
                      let _secondaries = [...secondaries];
                      _secondaries[index].city_id = e.value;
                      setSecondaries(_secondaries);
                    }}
                    placeholder="..."
                    name="secondaries[].city_id"
                  />
                </Col>
              </Row>
              {permissions.institutions.update && (
                <>
                  <div className="divisor mt-4 mb-3"></div>
                  <Row>
                    <Col className="d-flex justify-content-end">
                      {!el.id && (
                        <button type="button" onClick={() => removeSecondary(index)} className={styleButton.button_error_soft}>
                          <IcMenos/>
                          <span>
                            remover
                          </span>
                        </button>
                      )}
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        )
      })
      let DOM = (
        <>
          <Row>
            <Col>
              {rows}
            </Col>
          </Row>
          {permissions.institutions.update && (
            <Row className="mt-1 mb-4">
              <Col>
                <button onClick={() => addSecondary()} className={styleButton.button_success_soft} type="button">
                  <IcMais/>
                  <span>
                    adicionar novo campus
                  </span>
                </button>
              </Col>
            </Row>

          )}
        </>
      )
      setSecondaryDOM(DOM)
    }, [secondaries, JSON.stringify(cities_sec), secondariesLoad])
    const addSecondary = () => {
      setSecondaries([...secondaries, {title: '',state_id: '',city_id: ''}])
    }
    const removeSecondary = i => {
      let update = [...secondaries]
      let updateCities = [...cities_sec]
      update.splice(i, 1)
      updateCities.splice(i, 1)
      setSecondaries(update)
      setCities_sec(updateCities)
    }

  useEffect(() => {
    setbreadcrumb([
      { label: "Instituições", url: "/institutions" },
      {...institution?.title ? { label: institution?.title } : { label: "Nova Instituição"}}
    ])
  }, [institution]);

  const [loadingRequest, setloadingRequest] = useState(false);
  
  return (
    <Main>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Curso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='lince-input'>
            <span className='lince-input_label'>Curso</span>
            <div className='lince-input__text'>
              <Form.Control 
                type='text' 
                onChange={handleCourse} 
                name="title" 
                value={newCourse}/>
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <button className={styleButton.button_primary} onClick={() => saveCourse()} type="button">Adicionar</button>
        </Modal.Footer>
      </Modal>
      
      {!loadingPage ? (
        <Content className='inner-page'>
          <Row className="mb-4">
            <Col>
              <h2 className="page-title">{institucionId ? 'Editar' : 'Nova'} Instituição de Ensino</h2>
            </Col>
          </Row>
          <Form>
            <Row>
              <Col md={6} className='pr-md-5'>
                <Row>
                  <Col>
                    <Form.Group className='lince-input' controlId="validationCustom01">
                      <span className='lince-input_label'>Nome <Required /></span>
                      <div className='lince-input__text'>
                        <Form.Control 
                          disabled={!permissions.institutions.update}
                          type='text' 
                          onChange={e => { setInstitution({...institution, title: e.target.value})}} 
                          name="institution.title" 
                          value={institution.title}/>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className='mt-2'>
                  <Col>
                    <Form.Group className='lince-input'>
                      <span className='lince-input_label'>Campus Principal <Required /></span>
                      <div className='lince-input__text'>
                        <Form.Control
                          disabled={!permissions.institutions.update}
                          type='text' 
                          onChange={e => {setInstitution({...institution, campus_name: e.target.value})}} 
                          name="institution.campus_name" 
                          value={institution.campus_name}/>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className='mt-2'>
                  <Col sm={1}>
                    <img src={contextArrow} alt="" />
                  </Col>
                  <Col>
                    <Form.Group className="selectContainer">
                      <span className='lince-input_label'>Estado <Required /></span>
                      <Slct
                        isDisabled={!permissions.institutions.update}
                        options={states}
                        className="w-100"
                        onChange={e => {setState(e.value)}}
                        value={state}
                        placeholder="..."
                        name="state"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="selectContainer">
                      <span className='lince-input_label'>Cidade <Required /></span>
                      <Slct
                        isDisabled={!permissions.institutions.update}
                        options={cities}
                        className="w-100"
                        onChange={e => {setCity(e.value)}}
                        value={city}
                        placeholder="..."
                        name="city"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <div className="divisor mt-3 mb-3"></div>
                {secondaryDOM}

                <Row className='mt-3'>
                  <Col>
                    <Form.Group className='lince-input'>
                      <span className='lince-input_label'>Informações Adicionais</span>
                        <textarea
                          disabled={!permissions.institutions.update}
                          rows='5'
                          onChange={__ev => {
                            setInstitution({
                              ...institution, 
                              description: __ev.target.value  
                            });
                          }}
                          name="description"
                          value={institution.description}
                        ></textarea>
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className='pl-md-5'>
                <Row>
                  <Col>
                    <span className='lince-input_label'>Cursos Ativos</span>
                    <p className="small-label m-0">Aqui estão todos os cursos cadastrados no seu banco de dados, selecione aqueles que estão presentes nesta instituição.</p>
                  </Col>
                </Row>
                <Row className='mt-3'>
                  {courses.length > 0 &&
                  courses.map((course, index) => (
                    <Col sm={12} key={`course-${course.id}`} className="d-flex flex-column">
                      <CheckboxList
                        disabled={!permissions.institutions.update}
                        label={course.title}
                        name={course.id}
                        status={checked.checkState[course.id] === undefined ? false : checked.checkState[course.id]}
                        onChange={handleCheckboxChange}
                        className={checked.checkState[course.id] ? 'active' : ''} colorScheme="simple"
                      />
                    </Col>
                  ))}
                  {permissions.institutions.update && (
                    <Col sm={12} className="mt-2 d-flex justify-content-end">
                      <button onClick={handleShow} type="button" className={styleButton.button_success_soft}>
                        <div className="icon">
                          <IcMais/>
                        </div>
                        <span>
                          adicionar novo curso
                        </span>
                      </button>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
            <Row className='inner-page__actions mt-3'>
              <Col className='d-flex justify-content-between'>
                <div className='inner-page__actions__group'>
                  {permissions.institutions.update && (
                    <>
                      {institucionId && (
                          <Button
                            color="error"
                            loading={loadingRequest}
                            onClick={() => deleteContent(institucionId)} 
                          >
                            Apagar
                          </Button>
                      )}
                    </>
                  )}
                </div>
                {permissions.institutions.update && (
                  <div className='inner-page__actions__group'>
                    <Button
                      loading={loadingRequest}
                      onClick={handleSubmit}
                    >
                      Salvar
                    </Button>
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
